export default "/images/vendor/flag-icon-css/flags/4x3/ge.svg?fc9c4dcd0fd855eb51a3f47fec2a0f95";